import { ToolbarButton as e } from "./toolbar-button.mjs";
import { Select as t } from "@systemeio/components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { ChevronDownIcon as i } from "@systemeio/icons";
//#region src/components/content-controls/toolbar-select.tsx
function a({ options: e }) {
	return /* @__PURE__ */ n(t.Content, { children: /* @__PURE__ */ n(t.List, { children: e.map((e) => /* @__PURE__ */ n(t.Option, {
		value: e.value,
		children: e.customLabel ?? e.label
	}, String(e.value))) }) });
}
function o({ children: o, clearLabel: s, disabled: c, label: l, labelledByContent: u, onChange: d, onClear: f, options: p, value: m }) {
	return /* @__PURE__ */ r(t.Root, {
		disabled: c,
		drawerTitle: l,
		items: p,
		onValueChange: (e) => d(e),
		value: m ?? null,
		children: [/* @__PURE__ */ r(e, {
			disabled: c,
			label: l,
			labelledByContent: u,
			render: /* @__PURE__ */ n(t.Trigger, { unstyled: !0 }),
			size: "sm",
			children: [
				o,
				f && m != null ? /* @__PURE__ */ n(t.Clear, {
					"aria-label": s,
					className: "size-4 [&>svg]:size-4",
					onClick: f
				}) : null,
				/* @__PURE__ */ n(i, { className: "transition-base data-popup-open:rotate-180" })
			]
		}), /* @__PURE__ */ n(a, { options: p })]
	});
}
//#endregion
export { o as ToolbarSelect, a as ToolbarSelectOptions };
